var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonFunc01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 506,
    height: 392,
    viewBox: "0 0 506 392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1072",
    x: 187.869,
    y: 113.346,
    width: 143,
    height: 143,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "common-func01",
    transform: "translate(13010 16331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_481",
    "data-name": "\\uC0AC\\uAC01\\uD615 481",
    width: 506,
    height: 392,
    rx: 20,
    transform: "translate(-13010 -16331)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2776",
    "data-name": "\\uADF8\\uB8F9 2776",
    transform: "translate(-14181.131 -20574.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2774",
    "data-name": "\\uADF8\\uB8F9 2774",
    transform: "translate(170 -2810.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2626",
    "data-name": "\\uD328\\uC2A4 2626",
    d: "M688.112,516.987a94.86,94.86,0,0,1-41.346,2.184c-27.966-4.754-86.15-16.271-131.955,17.789-65.137,48.436-60.938,140.164-9.848,183.218,49.448,41.669,106.2,21.814,156.717,10.336s89.886,20.452,144.995,5.527c35.073-9.5,75.941-72.125,42.346-123.062a40.122,40.122,0,0,1-5.705-30.941c2.21-9.749,2.907-22.628-3.1-35.222C820.885,506.318,753.748,498.707,688.112,516.987Z",
    transform: "translate(592.725 6627.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_940",
    "data-name": "\\uC0AC\\uAC01\\uD615 940",
    width: 58.153,
    height: 34.909,
    transform: "translate(1227.465 7320.196)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_941",
    "data-name": "\\uC0AC\\uAC01\\uD615 941",
    width: 114.57,
    height: 15.134,
    transform: "translate(1199.254 7354.771)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_942",
    "data-name": "\\uC0AC\\uAC01\\uD615 942",
    width: 271.077,
    height: 185.138,
    rx: 20,
    transform: "translate(1121 7138)",
    fill: "#12233a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_943",
    "data-name": "\\uC0AC\\uAC01\\uD615 943",
    width: 253.129,
    height: 170.625,
    rx: 20,
    transform: "translate(1130 7146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "comment-solid",
    d: "M40.271,32c22.243,0,40.271,14.645,40.271,32.72,0,7.8-3.366,14.944-8.966,20.56,1.966,7.928,8.542,14.991,8.62,15.07a1.251,1.251,0,0,1,.236,1.369,1.232,1.232,0,0,1-1.148.755,35.975,35.975,0,0,1-22.117-8.086,47.975,47.975,0,0,1-16.9,3.052C18.027,97.44,0,82.794,0,64.72S18.027,32,40.271,32Z",
    transform: "translate(1080.895 7095.526)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_",
    "data-name": "user-solid (1)",
    d: "M19.8,22.633A11.316,11.316,0,1,0,8.487,11.318,11.316,11.316,0,0,0,19.8,22.633Zm7.922,2.829H26.249a15.39,15.39,0,0,1-12.89,0H11.882A11.885,11.885,0,0,0,0,37.344v3.678a4.245,4.245,0,0,0,4.243,4.244H35.364a4.245,4.245,0,0,0,4.244-4.243V37.344A11.885,11.885,0,0,0,27.725,25.462Z",
    transform: "translate(1285.618 7327.569)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_2",
    "data-name": "user-solid (1)",
    d: "M19.8,22.633A11.316,11.316,0,1,0,8.487,11.318,11.316,11.316,0,0,0,19.8,22.633Zm7.922,2.829H26.249a15.39,15.39,0,0,1-12.89,0H11.882A11.885,11.885,0,0,0,0,37.344v3.678a4.245,4.245,0,0,0,4.243,4.244H35.364a4.245,4.245,0,0,0,4.244-4.243V37.344A11.885,11.885,0,0,0,27.725,25.462Z",
    transform: "translate(1144.131 7327.569)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_3",
    "data-name": "user-solid (1)",
    d: "M19.8,22.633A11.316,11.316,0,1,0,8.487,11.318,11.316,11.316,0,0,0,19.8,22.633Zm7.922,2.829H26.249a15.39,15.39,0,0,1-12.89,0H11.882A11.885,11.885,0,0,0,0,37.344v3.678a4.245,4.245,0,0,0,4.243,4.244H35.364a4.245,4.245,0,0,0,4.244-4.243V37.344A11.885,11.885,0,0,0,27.725,25.462Z",
    transform: "translate(1370.749 7327.569)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_4",
    "data-name": "user-solid (1)",
    d: "M19.8,22.633A11.316,11.316,0,1,0,8.487,11.318,11.316,11.316,0,0,0,19.8,22.633Zm7.922,2.829H26.249a15.39,15.39,0,0,1-12.89,0H11.882A11.885,11.885,0,0,0,0,37.344v3.678a4.245,4.245,0,0,0,4.243,4.244H35.364a4.245,4.245,0,0,0,4.244-4.243V37.344A11.885,11.885,0,0,0,27.725,25.462Z",
    transform: "translate(1101.565 7327.569)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_5",
    "data-name": "user-solid (1)",
    d: "M19.8,22.633A11.316,11.316,0,1,0,8.487,11.318,11.316,11.316,0,0,0,19.8,22.633Zm7.922,2.829H26.249a15.39,15.39,0,0,1-12.89,0H11.882A11.885,11.885,0,0,0,0,37.344v3.678a4.245,4.245,0,0,0,4.243,4.244H35.364a4.245,4.245,0,0,0,4.244-4.243V37.344A11.885,11.885,0,0,0,27.725,25.462Z",
    transform: "translate(1328.183 7327.569)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid_1_6",
    "data-name": "user-solid (1)",
    d: "M19.8,22.633A11.316,11.316,0,1,0,8.487,11.318,11.316,11.316,0,0,0,19.8,22.633Zm7.922,2.829H26.249a15.39,15.39,0,0,1-12.89,0H11.882A11.885,11.885,0,0,0,0,37.344v3.678a4.245,4.245,0,0,0,4.243,4.244H35.364a4.245,4.245,0,0,0,4.244-4.243V37.344A11.885,11.885,0,0,0,27.725,25.462Z",
    transform: "translate(1186.696 7327.569)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "envelope-solid",
    d: "M26.3,70.64a.315.315,0,0,1,.508.246V81.6A2.514,2.514,0,0,1,24.3,84.109H2.514A2.514,2.514,0,0,1,0,81.6V70.9a.313.313,0,0,1,.508-.246c1.173.911,2.728,2.069,8.07,5.949,1.1.806,2.969,2.5,4.828,2.493,1.87.016,3.771-1.718,4.834-2.493C23.581,72.714,25.131,71.552,26.3,70.64ZM13.4,77.406c1.215.021,2.964-1.529,3.844-2.168,6.949-5.043,7.478-5.483,9.081-6.74a1.253,1.253,0,0,0,.482-.99v-.995A2.514,2.514,0,0,0,24.3,64H2.514A2.514,2.514,0,0,0,0,66.514v1a1.261,1.261,0,0,0,.482.99c1.6,1.252,2.131,1.7,9.081,6.74.879.638,2.628,2.188,3.843,2.167Z",
    transform: "translate(1107.758 7085.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_944",
    "data-name": "\\uC0AC\\uAC01\\uD615 944",
    width: 28,
    height: 11,
    transform: "translate(1150 7211)",
    fill: "#eff0f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_947",
    "data-name": "\\uC0AC\\uAC01\\uD615 947",
    width: 28,
    height: 11,
    transform: "translate(1319 7271)",
    fill: "#ccd1e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_945",
    "data-name": "\\uC0AC\\uAC01\\uD615 945",
    width: 28,
    height: 11,
    transform: "translate(1159 7222)",
    fill: "#e2e6f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_946",
    "data-name": "\\uC0AC\\uAC01\\uD615 946",
    width: 28,
    height: 11,
    transform: "translate(1328 7282)",
    fill: "#e2e6f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_948",
    "data-name": "\\uC0AC\\uAC01\\uD615 948",
    width: 28,
    height: 11,
    transform: "translate(1207 7293)",
    fill: "#e2e6f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_949",
    "data-name": "\\uC0AC\\uAC01\\uD615 949",
    width: 28,
    height: 11,
    transform: "translate(1260 7158)",
    fill: "#e2e6f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_176",
    "data-name": "\\uD0C0\\uC6D0 176",
    transform: "translate(1190 7163)",
    fill: "#fff",
    stroke: "#2d50b8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_179",
    "data-name": "\\uD0C0\\uC6D0 179",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(1162 7281)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_177",
    "data-name": "\\uD0C0\\uC6D0 177",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1183 7178)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_178",
    "data-name": "\\uD0C0\\uC6D0 178",
    transform: "translate(1179 7273)",
    fill: "#fff",
    stroke: "#2d50b8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_180",
    "data-name": "\\uD0C0\\uC6D0 180",
    transform: "translate(1331 7213)",
    fill: "#fff",
    stroke: "#2d50b8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_181",
    "data-name": "\\uD0C0\\uC6D0 181",
    transform: "translate(1345 7168)",
    fill: "#fff",
    stroke: "#2d50b8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_182",
    "data-name": "\\uD0C0\\uC6D0 182",
    transform: "translate(1343 7249)",
    fill: "#2d50b8",
    stroke: "#2d50b8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1171.13, 4243.65)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1072-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1072",
    width: 107,
    height: 107,
    rx: 10,
    transform: "translate(202.87 125.35)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5071",
    "data-name": "\\uD328\\uC2A4 5071",
    d: "M3.184-9.952H6.56v-1.712H1.1v9.728H2.128a27.035,27.035,0,0,0,5.248-.4l-.16-1.712a24.857,24.857,0,0,1-4.032.368Zm8.144-3.424V-7.7H10v-5.392H8.032V.688H10V-6h1.328V1.376h2V-13.376Zm4.9,1.536v1.68H21.14c-.3,3.264-1.936,5.568-5.7,7.376l1.1,1.664c5.236-2.528,6.76-6.208,6.76-10.72Zm9.328-1.536V1.36H27.68V-13.376Zm16.816.032H40.24V-2.768h2.128ZM32.4-8.672a1.838,1.838,0,0,1,.547-1.4,1.838,1.838,0,0,1,1.4-.524,1.818,1.818,0,0,1,1.4.523,1.818,1.818,0,0,1,.535,1.4,1.822,1.822,0,0,1-.544,1.382,1.822,1.822,0,0,1-1.392.518,1.843,1.843,0,0,1-1.4-.519A1.843,1.843,0,0,1,32.4-8.672Zm5.952,0a3.782,3.782,0,0,0-1.2-2.729,3.782,3.782,0,0,0-2.8-1.015A3.8,3.8,0,0,0,31.544-11.4a3.8,3.8,0,0,0-1.208,2.73A3.8,3.8,0,0,0,31.55-5.953a3.8,3.8,0,0,0,2.8,1.009,3.789,3.789,0,0,0,2.795-1.011,3.789,3.789,0,0,0,1.205-2.717ZM34.672-.56V-3.808H32.56V1.12H42.736V-.56Zm17.7-4.24v1.44H55.14v1.168h2.112V-13.36H55.136V-4.8ZM49.54-11.328c.976,0,1.664.384,1.664,1.1S50.516-9.14,49.54-9.14c-.992,0-1.68-.368-1.68-1.088s.684-1.1,1.676-1.1Zm0,3.728c2.144,0,3.664-1.056,3.664-2.624s-1.52-2.64-3.664-2.64c-2.16,0-3.664,1.072-3.664,2.64s1.5,2.624,3.66,2.624ZM48.752-.56V-2.576h2.032V-5.36c1.184-.1,2.368-.224,3.52-.416l-.144-1.5a80.721,80.721,0,0,1-9.376.448l.272,1.68c1.1,0,2.336-.016,3.632-.08V-3.26H46.64V1.12H57.568V-.56Z",
    transform: "translate(1398 4402)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5070",
    "data-name": "\\uD328\\uC2A4 5070",
    d: "M8.768.448c4.512,0,8.32-2.464,8.32-6.688a5.808,5.808,0,0,0-4.7-5.7v-.16c2.464-.992,3.936-2.72,3.936-5.216,0-3.968-3.1-6.208-7.68-6.208a10.538,10.538,0,0,0-7.1,2.944l2.4,2.88a6.478,6.478,0,0,1,4.48-2.112c2.016,0,3.168,1.056,3.168,2.848,0,1.984-1.408,3.424-5.76,3.424v3.392c5.152,0,6.528,1.376,6.528,3.616,0,1.984-1.632,3.136-4.032,3.136A7.522,7.522,0,0,1,3.04-5.824L.832-2.848A10.066,10.066,0,0,0,8.768.448ZM20.224,0H36.1V-3.968H30.912c-1.12,0-2.688.128-3.872.256,4.224-4.416,7.936-8.576,7.936-12.608,0-4.352-2.976-7.2-7.456-7.2-3.232,0-5.344,1.28-7.52,3.616l2.56,2.56c1.216-1.312,2.624-2.464,4.352-2.464,2.272,0,3.552,1.408,3.552,3.744,0,3.424-4.064,7.456-10.24,13.344Z",
    transform: "translate(1409 4453)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1073",
    "data-name": "\\uC0AC\\uAC01\\uD615 1073",
    width: 38,
    height: 1,
    transform: "translate(1409 4415)",
    fill: "#2d50b8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFunc01);
export default __webpack_public_path__ + "static/media/common-func01.8ca9f769ee0c0dd7b487353de7a74b15.svg";
export { ForwardRef as ReactComponent };